/* DORYD product page */
(function () {
  if (window.__dhProduct) return;
  window.__dhProduct = true;

  function money(cents, sym) {
    var n = Math.round(cents) / 100;
    var s = n.toLocaleString('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return (sym || '₹') + s;
  }
  function num(el, k, d) { var v = parseFloat(el.dataset[k]); return isNaN(v) ? d : v; }

  function initProduct(root) {
    if (!root || root.dataset.dhInit) return;
    root.dataset.dhInit = '1';
    var sym = root.dataset.currency || '₹';

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-gal-track]');
    var slides = track ? track.children : [];
    var thumbs = root.querySelectorAll('[data-gal-thumbs] .dh-gal__thumb');
    var count = root.querySelector('[data-gal-count]');
    function cur() { return track ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function go(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = cur();
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      [].forEach.call(thumbs, function (t, j) {
        t.setAttribute('aria-current', j === i ? 'true' : 'false');
        if (j === i && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
      });
    }
    if (track) {
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      [].forEach.call(thumbs, function (t) { t.addEventListener('click', function () { go(+t.dataset.index); }); });
      var prev = root.querySelector('[data-gal-prev]'), next = root.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { go((cur() - 1 + slides.length) % slides.length); });
      if (next) next.addEventListener('click', function () { go((cur() + 1) % slides.length); });
    }
    var dlg = root.querySelector('[data-gal-dialog]');
    var zoomBtn = root.querySelector('[data-gal-zoom]');
    if (dlg && zoomBtn && dlg.showModal) {
      var ztrack = dlg.querySelector('[data-zoom-track]');
      zoomBtn.addEventListener('click', function () {
        var i = cur();
        dlg.showModal();
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () { ztrack.scrollLeft = ztrack.clientWidth * i; });
      });
      dlg.querySelector('[data-gal-close]').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        go(Math.round(ztrack.scrollLeft / ztrack.clientWidth), false);
      });
    } else if (zoomBtn) { zoomBtn.hidden = true; }

    /* keep the sticky gallery just below a pinned header (themes without --header-height) */
    var gal = root.querySelector('.dh-gal--sticky');
    if (gal) {
      var pc = gal.closest('.page-container');
      if (pc && getComputedStyle(pc).overflow !== 'visible' && getComputedStyle(pc).overflowY !== 'clip') pc.style.overflow = 'clip';
      var hdr = document.querySelector('.site-header--sticky, header.site-header, sticky-header, .shopify-section-header-sticky');
      var placeTop = function () {
        var off = 0;
        if (hdr) {
          var cs = getComputedStyle(hdr), r = hdr.getBoundingClientRect();
          if ((cs.position === 'fixed' || cs.position === 'sticky') && r.bottom > 0) off = Math.round(r.bottom);
          else if (hdr.parentElement) {
            var ps = getComputedStyle(hdr.parentElement), pr = hdr.parentElement.getBoundingClientRect();
            if ((ps.position === 'fixed' || ps.position === 'sticky') && pr.bottom > 0) off = Math.round(pr.bottom);
          }
        }
        root.style.setProperty('--dh-sticky-top', off + 'px');
      };
      var ticking = false;
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { placeTop(); ticking = false; }); } }, { passive: true });
      window.addEventListener('resize', placeTop);
      placeTop();
    }

    /* ---------- price lines ---------- */
    var priceEl = root.querySelector('[data-price]');
    var cmpEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var onlineEl = root.querySelector('[data-pay-online]');
    var codEl = root.querySelector('[data-pay-cod]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var off = num(root, 'onlineOff', 5), freeOnline = num(root, 'freeOnline', 699) * 100, ship = num(root, 'shipFee', 59) * 100;
    var codFee = num(root, 'codFee', 39) * 100, codFree = num(root, 'codFree', 999) * 100, codMin = num(root, 'codMin', 499) * 100, codMax = num(root, 'codMax', 2999) * 100;
    function payLines(price) {
      if (onlineEl) {
        var on = Math.round(price * (100 - off) / 100);
        var freeO = price >= freeOnline;
        onlineEl.innerHTML = '💳 <b>Pay online: ' + money(on + (freeO ? 0 : ship), sym) + '</b> <span>(' + (freeO ? 'FREE delivery' : money(ship, sym) + ' delivery') + (off ? ' + ' + off + '% off' : '') + ')</span>';
      }
      if (codEl) {
        if (price < codMin) codEl.innerHTML = '💵 <span>COD available on orders ' + money(codMin, sym) + '+</span>';
        else if (price > codMax) codEl.innerHTML = '💵 <span>COD available up to ' + money(codMax, sym) + '. Pay online for this order.</span>';
        else {
          var freeC = price >= codFree;
          codEl.innerHTML = '💵 <b>COD: ' + money(price + codFee + (freeC ? 0 : ship), sym) + '</b> <span>(' + (freeC ? 'FREE delivery' : money(ship, sym) + ' delivery') + ', ' + money(codFee, sym) + ' COD fee)</span>';
        }
      }
    }
    function setPrice(v) {
      if (priceEl) priceEl.textContent = money(v.price, sym);
      if (stickyPrice) stickyPrice.textContent = money(v.price, sym);
      var hasCmp = v.compare > v.price;
      if (cmpEl) { cmpEl.hidden = !hasCmp; if (hasCmp) cmpEl.textContent = money(v.compare, sym); }
      if (saveEl) { saveEl.hidden = !hasCmp; if (hasCmp) saveEl.textContent = 'Save ' + money(v.compare - v.price, sym); }
      payLines(v.price);
    }

    /* ---------- variants ---------- */
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-input]');
    var atc = root.querySelector('[data-atc]');
    var buyNow = root.querySelector('[data-buy-now]');
    var atcLabel = atc ? atc.textContent.trim() : 'Add to cart';
    if (atc && atc.disabled) atcLabel = 'Add to cart';
    var vp = root.querySelector('[data-vp]');
    var variants = [];
    if (vp) { try { variants = JSON.parse(vp.querySelector('[data-variants]').textContent); } catch (e) {} }
    var currentId = idInput ? +idInput.value : 0;
    var current = variants.filter(function (v) { return v.id === currentId; })[0];

    function setButtons(v) {
      var ok = v && v.available;
      [atc, buyNow].forEach(function (b) { if (b) b.disabled = !ok; });
      if (atc) atc.textContent = !v ? 'Unavailable' : ok ? atcLabel : 'Sold out';
    }
    function markOptions() {
      if (!vp || !variants.length) return;
      var sel = selected();
      vp.querySelectorAll('input[type=radio]').forEach(function (inp) {
        var idx = +inp.dataset.index;
        var test = sel.slice(); test[idx] = inp.value;
        var any = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
        inp.classList.toggle('is-off', !any);
      });
    }
    function selected() {
      var out = [];
      vp.querySelectorAll('.dh-vp__opt').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked');
        out[i] = c ? c.value : null;
        var lab = root.querySelector('[data-opt-value="' + i + '"]');
        if (lab && c) lab.textContent = c.value;
      });
      return out;
    }
    if (vp) {
      vp.addEventListener('change', function () {
        var sel = selected();
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
        setButtons(v);
        markOptions();
        if (!v) return;
        current = v;
        if (idInput) idInput.value = v.id;
        setPrice(v);
        if (v.media && track) {
          var s = track.querySelector('[data-media-id="' + v.media + '"]');
          if (s) go([].indexOf.call(slides, s));
        }
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
        document.dispatchEvent(new CustomEvent('dh:variant', { detail: { variant: v } }));
      });
      markOptions();
    }
    if (current) payLines(current.price);
    else payLines(parseInt(root.dataset.firstPrice || '0', 10));

    /* ---------- price per piece + pack sub-labels ---------- */
    var ppc = root.querySelector('[data-ppc]');
    var PCS_RE = /(?:set|pack|box|combo|bundle)\s*(?:of\s*)?(\d+)|(\d+)\s*(?:pcs?\b|pieces?|pc\b|claws?|clips?|pens?)/i;
    function piecesOfText(t) { var m = PCS_RE.exec(t || ''); return m ? +(m[1] || m[2]) : 0; }
    function piecesOf(v) {
      if (!v) return 0;
      if (v.pieces > 1) return v.pieces;
      for (var i = 0; i < v.options.length; i++) { var n = piecesOfText(v.options[i]); if (n > 1) return n; }
      return piecesOfText(v.title);
    }
    function packIndex(v) {
      if (!v) return -1;
      for (var i = 0; i < v.options.length; i++) if (piecesOfText(v.options[i]) > 1) return i;
      return -1;
    }
    function perPc(v) { var n = piecesOf(v); return n > 1 ? v.price / n : 0; }
    function siblings(v, k) {
      return variants.filter(function (x) { return x.options.every(function (o, i) { return i === k || o === v.options[i]; }); });
    }
    function updatePieces(v) {
      var bestLbl = ppc ? ppc.dataset.pillBest : 'Best value';
      var k = packIndex(v);
      if (vp && k > -1) {
        var sibs = siblings(v, k), min = Infinity;
        sibs.forEach(function (x) { var pp = perPc(x); if (pp && pp < min) min = pp; });
        vp.querySelectorAll('input[data-index="' + k + '"]').forEach(function (inp) {
          var sm = inp.nextElementSibling && inp.nextElementSibling.querySelector('[data-pc]');
          if (!sm) return;
          var x = sibs.filter(function (y) { return y.options[k] === inp.value; })[0];
          var pp = x ? perPc(x) : 0;
          var best = pp && sibs.length > 1 && Math.abs(pp - min) < 1;
          sm.textContent = pp ? money(Math.round(pp / 100) * 100, sym) + '/pc' + (best ? ' · ' + bestLbl : '') : '';
          sm.classList.toggle('is-best', !!best);
        });
      }
      if (!ppc) return;
      var n = v ? piecesOf(v) : parseInt(ppc.dataset.pieces || '0', 10);
      var price = v ? v.price : parseInt(root.dataset.firstPrice || '0', 10);
      if (!(n > 1) || !price) { ppc.hidden = true; return; }
      ppc.hidden = false;
      var each = price / n;
      ppc.querySelector('[data-ppc-price]').textContent = money(Math.round(each / 100) * 100, sym);
      ppc.querySelector('[data-ppc-pack]').textContent = '· ' + (k > -1 ? v.options[k] : n + ' pieces');
      var bestEl = ppc.querySelector('[data-ppc-best]');
      bestEl.hidden = true;
      if (v && k > -1) {
        var worst = null;
        siblings(v, k).forEach(function (x) { var pp = perPc(x); if (pp > each && (!worst || pp > perPc(worst))) worst = x; });
        if (worst) {
          var wpp = perPc(worst), save = Math.round((wpp - each) / 100) * 100, pct = Math.round((wpp - each) / wpp * 100);
          if (save > 0) {
            bestEl.textContent = '✓ ' + (ppc.dataset.best || '').replace('[save]', money(save, sym)).replace('[percent]', pct).replace('[pack]', worst.options[k]);
            bestEl.hidden = false;
          }
        }
      }
    }
    updatePieces(current);
    document.addEventListener('dh:variant', function (e) { if (e.detail && e.detail.variant) updatePieces(e.detail.variant); });

    /* ---------- quantity + buy now ---------- */
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = b.parentNode.querySelector('input');
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        buyNow.disabled = true;
        var err = root.querySelector('[data-buy-err]');
        fetch((window.routes && routes.cart_add_url) || '/cart/add', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +idInput.value, quantity: +(form.querySelector('[name=quantity]') || { value: 1 }).value || 1 }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { if (err) { err.hidden = false; err.textContent = res.j.description || res.j.message || 'Could not add to cart'; } buyNow.disabled = false; return; }
            window.location.href = '/checkout';
          })
          .catch(function () { buyNow.disabled = false; form.submit(); });
      });
    }

    /* ---------- delivery estimate ---------- */
    var etaEl = root.querySelector('[data-eta]');
    function addWorkDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
    function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    var cutoff = num(root, 'cutoff', 16);
    function dispatchDay(now) {
      var d = new Date(now);
      if (d.getDay() === 0 || d.getHours() >= cutoff) { d = addWorkDays(d, 1); }
      return d;
    }
    if (etaEl) {
      var base = dispatchDay(new Date());
      etaEl.textContent = fmt(addWorkDays(base, num(root, 'etaMin', 3))) + ' – ' + fmt(addWorkDays(base, num(root, 'etaMax', 6)));
    }

    /* ---------- ships today countdown ---------- */
    var shipsEl = root.querySelector('[data-ships]');
    function tick() {
      if (!shipsEl) return;
      var now = new Date(), span = shipsEl.querySelector('span');
      var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
      if (now.getDay() !== 0 && now < end) {
        var m = Math.max(1, Math.round((end - now) / 60000));
        var t = (m >= 60 ? Math.floor(m / 60) + 'h ' : '') + (m % 60) + 'm';
        span.textContent = (shipsEl.dataset.today || '').replace('[time]', t);
      } else {
        var nd = addWorkDays(now, 1);
        var tomorrow = new Date(now); tomorrow.setDate(tomorrow.getDate() + 1);
        var day = nd.toDateString() === tomorrow.toDateString() ? 'tomorrow' : 'on ' + nd.toLocaleDateString('en-IN', { weekday: 'long' });
        span.textContent = (shipsEl.dataset.tomorrow || '').replace('[day]', day);
      }
    }
    if (shipsEl) { tick(); setInterval(tick, 30000); }

    /* ---------- scratch card ---------- */
    var sc = root.querySelector('[data-scratch]');
    if (sc) {
      var cv = sc.querySelector('[data-scratch-canvas]');
      var key = 'dh-scratch-' + sc.dataset.scratch;
      var done = false;
      try { done = localStorage.getItem(key) === '1'; } catch (e) {}
      var timerEl = sc.querySelector('[data-scratch-timer]'), timerOn = false;
      function startTimer() {
        if (!timerEl || timerOn) return;
        timerOn = true;
        timerEl.hidden = false;
        var run = function () {
          var now = new Date(), end = new Date(now); end.setHours(cutoff, 0, 0, 0);
          var span = timerEl.querySelector('span');
          if (now.getDay() !== 0 && now < end) {
            var m = Math.max(1, Math.round((end - now) / 60000));
            span.textContent = (timerEl.dataset.today || '').replace('[time]', (m >= 60 ? Math.floor(m / 60) + 'h ' : '') + (m % 60) + 'm');
          } else {
            var nd = addWorkDays(now, 1), tm = new Date(now); tm.setDate(tm.getDate() + 1);
            var day = nd.toDateString() === tm.toDateString() ? 'tomorrow' : 'on ' + nd.toLocaleDateString('en-IN', { weekday: 'long' });
            span.textContent = (timerEl.dataset.after || '').replace('[day]', day);
          }
        };
        run(); setInterval(run, 30000);
      }
      if (done) { cv.remove(); startTimer(); }
      else {
        var ctx = cv.getContext('2d');
        var paint = function () {
          var r = cv.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
          cv.width = r.width * dpr; cv.height = r.height * dpr;
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          var g = ctx.createLinearGradient(0, 0, r.width, r.height);
          g.addColorStop(0, '#C9CBD3'); g.addColorStop(.5, '#EEEFF3'); g.addColorStop(1, '#B9BCC6');
          ctx.globalCompositeOperation = 'source-over';
          ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
          ctx.fillStyle = '#5A5F70'; ctx.font = '800 20px Nunito, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(cv.dataset.label || 'Scratch here', r.width / 2, r.height / 2);
        };
        paint();
        var down = false, moves = 0;
        var scratch = function (e) {
          if (!down) return;
          var r = cv.getBoundingClientRect();
          ctx.globalCompositeOperation = 'destination-out';
          ctx.beginPath(); ctx.arc(e.clientX - r.left, e.clientY - r.top, 22, 0, Math.PI * 2); ctx.fill();
          if (++moves % 12 === 0) check();
        };
        var check = function () {
          var d = ctx.getImageData(0, 0, cv.width, cv.height).data, clear = 0, step = 40;
          for (var i = 3; i < d.length; i += 4 * step) if (d[i] === 0) clear++;
          if (clear / (d.length / (4 * step)) > 0.45) reveal();
        };
        var reveal = function () {
          cv.style.opacity = '0'; setTimeout(function () { cv.remove(); }, 400);
          try { localStorage.setItem(key, '1'); } catch (e) {}
          startTimer();
        };
        cv.addEventListener('pointerdown', function (e) { down = true; cv.setPointerCapture(e.pointerId); scratch(e); });
        cv.addEventListener('pointermove', scratch);
        cv.addEventListener('pointerup', function () { down = false; check(); });
        cv.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') reveal(); });
        cv.tabIndex = 0;
      }
      sc.addEventListener('click', function (e) {
        var b = e.target.closest('[data-copy]');
        if (!b) return;
        if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copy);
        b.textContent = 'Copied';
      });
    }

    /* ---------- sticky bar (mobile) ---------- */
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      }).observe(atc);
      sticky.querySelector('[data-sticky-btn]').addEventListener('click', function () {
        if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        atc.click();
      });
    }

    /* ---------- remember for recently viewed ---------- */
    try {
      var h = root.dataset.handle, list = JSON.parse(localStorage.getItem('dh-rv') || '[]');
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
      localStorage.setItem('dh-rv', JSON.stringify(list));
    } catch (e) {}
  }

  /* ---------- recently viewed ---------- */
  function initRecent(sec) {
    if (sec.dataset.dhInit) return;
    sec.dataset.dhInit = '1';
    var box = sec.querySelector('[data-rv-list]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem('dh-rv') || '[]'); } catch (e) {}
    var exclude = sec.dataset.exclude, limit = +sec.dataset.limit || 6, sym = sec.dataset.currency || '₹';
    list = list.filter(function (h) { return h !== exclude; }).slice(0, limit);
    if (!list.length) { if (!(window.Shopify && Shopify.designMode)) sec.hidden = true; return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) { sec.hidden = true; return; }
      box.innerHTML = items.map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          p.title.replace(/</g, '&lt;') + '<span>' + money(p.price, sym) + '</span></a>';
      }).join('');
    });
  }

  /* ---------- complete the set (recommendations) ---------- */
  function initSet(sec) {
    if (sec.dataset.dhInit) return;
    sec.dataset.dhInit = '1';
    var url = sec.dataset.url;
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-set-results]');
      var target = sec.querySelector('[data-set-results]');
      if (inner && inner.children.length && target) { target.innerHTML = inner.innerHTML; sec.hidden = false; }
      else if (!(window.Shopify && Shopify.designMode)) sec.hidden = true;
    }).catch(function () {});
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-dh-product]').forEach(initProduct);
    scope.querySelectorAll('[data-dh-recent]').forEach(initRecent);
    scope.querySelectorAll('[data-dh-set]').forEach(initSet);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
